/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_RenameInputs */

const es_sidebar_rename = /** @type {(inputs: Sidebar_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renombrar`)
};

const en_sidebar_rename = /** @type {(inputs: Sidebar_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Sidebar_RenameInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_rename = /** @type {((inputs?: Sidebar_RenameInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_RenameInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_rename(inputs)
	return en_sidebar_rename(inputs)
});
export { sidebar_rename as "sidebar.rename" }